"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGlobalStyles = void 0;
var core_1 = require("@material-ui/core");
var BREAKPOINTS = ["xs", "sm", "md", "lg", "xl"];
var COMMON_SPACINGS = [1, 2, 3, 4];
var marginHelpers = function (theme) {
    var classes = {};
    COMMON_SPACINGS.forEach(function (spacing) {
        classes[".mt-" + spacing] = { marginTop: theme.spacing(spacing) };
        classes[".mb-" + spacing] = { marginBottom: theme.spacing(spacing) };
        classes[".ml-" + spacing] = { marginLeft: theme.spacing(spacing) };
        classes[".mr-" + spacing] = { marginRight: theme.spacing(spacing) };
        classes[".mx-" + spacing] = {
            marginLeft: theme.spacing(spacing),
            marginRight: theme.spacing(spacing)
        };
        classes[".my-" + spacing] = {
            marginTop: theme.spacing(spacing),
            marginBottom: theme.spacing(spacing)
        };
        classes[".m-" + spacing] = {
            marginTop: theme.spacing(spacing),
            marginBottom: theme.spacing(spacing),
            marginLeft: theme.spacing(spacing),
            marginRight: theme.spacing(spacing)
        };
    });
    return classes;
};
var paddingHelpers = function (theme) {
    var classes = {};
    COMMON_SPACINGS.forEach(function (spacing) {
        classes[".pt-" + spacing] = { paddingTop: theme.spacing(spacing) };
        classes[".pb-" + spacing] = { paddingBottom: theme.spacing(spacing) };
        classes[".pl-" + spacing] = { paddingLeft: theme.spacing(spacing) };
        classes[".pr-" + spacing] = { paddingRight: theme.spacing(spacing) };
        classes[".px-" + spacing] = {
            paddingLeft: theme.spacing(spacing),
            paddingRight: theme.spacing(spacing)
        };
        classes[".py-" + spacing] = {
            paddingTop: theme.spacing(spacing),
            paddingBottom: theme.spacing(spacing)
        };
        classes[".p-" + spacing] = {
            paddingTop: theme.spacing(spacing),
            paddingBottom: theme.spacing(spacing),
            paddingLeft: theme.spacing(spacing),
            paddingRight: theme.spacing(spacing)
        };
    });
    return classes;
};
var breakpointHelpers = function (theme) {
    var classes = {};
    BREAKPOINTS.forEach(function (breakpoint) {
        classes[".max-width-" + breakpoint] = {
            maxWidth: theme.breakpoints.values[breakpoint]
        };
        classes[".min-width-" + breakpoint] = {
            minWidth: theme.breakpoints.values[breakpoint]
        };
        classes[".max-height-" + breakpoint] = {
            maxWidth: theme.breakpoints.values[breakpoint]
        };
        classes[".min-height-" + breakpoint] = {
            minWidth: theme.breakpoints.values[breakpoint]
        };
    });
    return classes;
};
var flexHelpers = function () {
    var classes = {
        ".flex-grow": {
            flexGrow: 1
        },
        ".flex-shrink": {
            flexShrink: 1
        },
        ".flex-grow-0": {
            flexGrow: 0
        },
        ".flex-shrink-0": {
            flexShrink: 0
        }
    };
    return classes;
};
/**
 * Elevation levels 0-10 as illustrated through box shadows
 */
var shadowHelpers = function () {
    var classes = {};
    var shadows = [
        { boxShadow: "none" },
        {
            boxShadow: "0 1px 1px 0 rgba(0,0,0,0.14), 0 2px 1px -1px rgba(0,0,0,0.12), 0 1px 3px 0 rgba(0,0,0,0.20)"
        },
        {
            boxShadow: "0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.20)"
        },
        {
            boxShadow: "0 3px 4px 0 rgba(0,0,0,0.14), 0 3px 3px -2px rgba(0,0,0,0.12), 0 1px 8px 0 rgba(0,0,0,0.20)"
        },
        {
            boxShadow: "0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12), 0 2px 4px -1px rgba(0,0,0,0.20)"
        },
        {
            boxShadow: "0 6px 10px 0 rgba(0,0,0,0.14), 0 1px 18px 0 rgba(0,0,0,0.12), 0 3px 5px -1px rgba(0,0,0,0.20)"
        },
        {
            boxShadow: "0 8px 10px 1px rgba(0,0,0,0.14), 0 3px 14px 2px rgba(0,0,0,0.12), 0 5px 5px -3px rgba(0,0,0,0.20)"
        },
        {
            boxShadow: "0 9px 12px 1px rgba(0,0,0,0.14), 0 3px 16px 2px rgba(0,0,0,0.12), 0 5px 6px -3px rgba(0,0,0,0.20)"
        },
        {
            boxShadow: "0 12px 17px 2px rgba(0,0,0,0.14), 0 5px 22px 4px rgba(0,0,0,0.12), 0 7px 8px -4px rgba(0,0,0,0.20)"
        },
        {
            boxShadow: "0 16px 24px 2px rgba(0,0,0,0.14), 0 6px 30px 5px rgba(0,0,0,0.12), 0 8px 10px -5px rgba(0,0,0,0.20)"
        },
        {
            boxShadow: "0 24px 38px 3px rgba(0,0,0,0.14), 0 9px 46px 8px rgba(0,0,0,0.12), 0 11px 15px -7px rgba(0,0,0,0.20)"
        }
    ];
    shadows.forEach(function (style, index) {
        classes[".elevation-" + index] = style;
    });
    return classes;
};
var useGlobalStyles = function (compiledTheme) { return core_1.makeStyles({
    "@global": __assign(__assign(__assign(__assign(__assign({ body: {
            width: "100%",
            height: "100%",
            margin: 0,
            padding: 0,
            overscrollBehavior: "none"
        }, html: {
            color: compiledTheme.palette.text.primary,
            backgroundColor: compiledTheme.palette.grey[100],
            width: "100%",
            height: "100%",
            margin: 0,
            padding: 0
        }, ".react-colorful": {
            boxSizing: "border-box",
            padding: "1rem",
            width: "100% !important"
        }, ".wavesurfer-handle": {
            cursor: "col-resize !important"
        }, "#root": {
            width: "100%",
            height: "100%"
        }, ".h-full": {
            height: "100%"
        }, ".w-full": {
            width: "100%"
        }, ".border-box": {
            boxSizing: "border-box"
        }, ".fill-absolute": {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%"
        } }, breakpointHelpers(compiledTheme)), marginHelpers(compiledTheme)), paddingHelpers(compiledTheme)), flexHelpers()), shadowHelpers())
}); };
exports.useGlobalStyles = useGlobalStyles;
